import { API_URL } from "../constants.js";
import axios from 'axios';
import middleware from '../util/middleware';

var request = axios.create({
    baseURL: API_URL,
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
    }
})

/**
 * Clase para ver el request de artículos auxiliares
 */
class ArticulosAuxiliaresRequest {
    /**
     * Llamada el endpoint de django para obtener los artículos auxiliares
     * en la BD
     * @param: nada
     * @return: Una lista de artículos.
     */
    static ListarArticulosAuxiliares(filtros) {
        return middleware.hasAuth(() => request.get(`articulos-auxiliares/`, {
            params: {
                filtro: filtros?.filtro ?? undefined,
                page: filtros?.page
            }
        }))
    }

    /**
     * Llamada el endpoint de django para obtener los artículos auxiliares
     * en la BD
     * @param: nada
     * @return: Una lista de artículos.
     */
    static ListarArticulosAuxiliaresEstatus(filtros) {
        return middleware.hasAuth(() => request.get(`articulos`, {
            params: {
                drive_id: filtros?.drive_id?.toString(),
                region_id: filtros?.region_id?.toString(),
                plaza_id: filtros?.plaza_id?.toString(),
                sucursal_id: filtros?.sucursal_id?.toString(),
                busqueda: filtros?.filtro ?? undefined,
                page: filtros?.page
            }
        }))
    }

    /**
     * Llamada el endpoint de django para obtener las equivalencias auxiliares
     * en la BD
     * @param: nada
     * @return: Una lista de equivalencias.
     */
    static ListarEquivalenciasAuxiliar(data) {
        return middleware.hasAuth(() => request.get(`equivalencia-articulo-auxiliares/`, {
            params: {
                sitios: data?.sitios.toString(),
                articulo_id: data?.articulo_id
            }
        }))
    }

    /**
     * Llamada el endpoint de django para crear / editar una categoría
     * @param: value. id de la categoría
     * @param: data. objeto con información de la categoría
     * @return: Mensaje de éxito o error.
     */
    static EditarEquivalenciasAuxiliar(data) {
        return middleware.hasAuth(() => request.post(`equivalencia-articulo-auxiliares/`, data));
    }

    /**
     * Llamada el endpoint de django para eliminar categoría
     * @param: value. id de la categoría
     * @return: Mensaje de éxito o error.
     */
    static EliminarEquivalenciaAuxiliar(value) {
        return middleware.hasAuth(() => request.put(`equivalencia-articulo-auxiliares/delete/${value}/`));
    }

    /**
     * Llamada el endpoint de django para crear / editar estatus de un producto
     * @param: data. objeto con información del producto
     * @return: Mensaje de éxito o error.
     */
    static EditarEstatusArticuloAuxiliar(data) {
        // const date = '"cuenta": {"ACTINDX": 1,"ACTNUMBR_1": "1000","ACTNUMBR_2": "000","ACTNUMBR_3": "000","ACTNUMBR_4": "000","ACTNUMBR_5": "000","ACTNUMBR_6": "000","ACTNUMBR_7": "000","ACTNUMBR_8": "0000","ACTNUMBR_9": "","ACTNUMBR_10": "","ACTNUMST": "1001-000-000-000-000-000-000-0000","DEX_ROW_ID": 1,"cuenta_contable": "1001-000-000-000-000-000-000-0000"}'
        return middleware.hasAuth(() => request.put(`articulos`, data));
    }

    /**
     * Llamada el endpoint de django para editar variables de modelo auxiliar
     * @param: data. objeto con información del producto
     * @return: Mensaje de éxito o error.
     */
    static EditarModeloPedidoAuxiliar(data) {
        return middleware.hasAuth(() => request.post(`sitios/modelo-pedido-auxiliar/`, data));
    }

    /**
     * Llamada el endpoint de django para obtener los modelos auxiliares
     * en la BD
     * @param: nada
     * @return: Una lista de modelos auxiliares.
     */
    static ListarModelosAuxiliar(filtros) {
        return middleware.hasAuth(() => request.get(`sitios/modelo-pedido-auxiliar/`, {
            params: {
                busqueda: filtros.busqueda,
                plazas_id: filtros.plazas_id,
                page: filtros.page,
            }
        }))
    }

    /**
     * Llamada el endpoint de django para obtener el detalle de un modelo
     * en la BD
     * @param: filtros. 
     */
    static DetalleModeloAuxiliar(filtros) {
        return middleware.hasAuth(() => request.get(`sitios/modelo-pedido-auxiliar/${filtros?.drives_id?.toString()}`, {
            params: {
                tipo_modelo: filtros?.tipo_modelo,
                categoria: filtros?.categoria,
                page: filtros.page,
            }
        }))
    }
}

export default ArticulosAuxiliaresRequest;